import ls from "services/ls";

export const ATTRIBUTION_WINDOW_DAYS = 30;

const KEY = "affattr";
const LEGACY_KEY = "afftoken";
const WINDOW_MS = ATTRIBUTION_WINDOW_DAYS * 24 * 60 * 60 * 1000;

// Records written before the attribution window existed carry no timestamp,
// so their real age is unknown: they are usable but never beat a fresh click.
function readRecord() {
  const rec = ls.get(KEY);
  if (rec && typeof rec === "object" && isToken(rec.token)) {
    // A record whose timestamp is missing or corrupt must never read as
    // "not expired yet" — that is exactly the indefinite storage we removed.
    const ts = Number(rec.ts);
    return Number.isFinite(ts)
      ? { token: String(rec.token), ts, legacy: false }
      : { token: String(rec.token), ts: Date.now(), legacy: true };
  }

  const legacy = ls.get(LEGACY_KEY);
  if (isToken(legacy)) {
    return { token: String(legacy), ts: Date.now(), legacy: true };
  }

  return null;
}

function isToken(value) {
  return (
    (typeof value === "string" && value.length > 0) || typeof value === "number"
  );
}

function isExpired(rec) {
  return Date.now() - rec.ts >= WINDOW_MS;
}

function write(token) {
  ls.set(KEY, { token: String(token), ts: Date.now() });
  ls.remove(LEGACY_KEY);
}

export function captureAffiliateToken(token) {
  if (!token) return;

  const rec = readRecord();
  if (rec && !rec.legacy && !isExpired(rec)) return;

  write(token);
}

export function getAffiliateToken() {
  const rec = readRecord();
  if (!rec) return null;

  if (isExpired(rec)) {
    ls.remove(KEY);
    ls.remove(LEGACY_KEY);
    return null;
  }

  if (rec.legacy) write(rec.token);

  return rec.token;
}
